// extracted by mini-css-extract-plugin
export default {"TextFieldLabel":"styles_TextFieldLabel__oksvo","contactItem":"styles_contactItem__1k0CF","contactIconItem":"styles_contactIconItem__zWukd","icon":"styles_icon__NQmGe"};